import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { GenericListPage } from '../../components/generic';
import { useAccountVesselScope } from '../../hooks/useAccountVesselScope';
import {
  VesselSparePendingDeliveriesListProvider,
  useVesselSparePendingDeliveriesListData,
  type VesselSparePendingPurchaseOrderRow,
} from './useData';
import { createVesselSparePendingDeliveriesModuleConfig, getColumns, getToolbarIcon } from './vesselSparePendingDeliveriesModuleConfig';

const List: React.FC = () => {
  const vid = useAccountVesselScope();

  const bundle = useMemo(
    () => (vid != null && Number.isFinite(vid) ? createVesselSparePendingDeliveriesModuleConfig(vid) : null),
    [vid],
  );

  const getTableActions = useCallback(
    (
      item: VesselSparePendingPurchaseOrderRow,
      _onDelete: (id: number) => void,
      _c?: unknown,
      _ctx?: unknown,
      _options?: { canDelete?: boolean; canEdit?: boolean },
    ): React.ReactNode => (
      <div className="flex items-center flex-nowrap">
        <Link
          to={`/spare-pending-deliveries/${item.id}`}
          className="p-1 text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50 rounded-lg transition-colors"
          onClick={(e) => e.stopPropagation()}
          title="View"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        </Link>
      </div>
    ),
    [],
  );

  const config = useMemo(() => {
    if (!bundle) return null;
    return {
      ...bundle.moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    };
  }, [bundle, getTableActions]);

  if (vid == null || !Number.isFinite(vid) || !config) {
    return <p className="text-sm text-red-600 dark:text-red-400">Invalid vessel.</p>;
  }

  return (
    <VesselSparePendingDeliveriesListProvider vesselId={vid}>
      <GenericListPage<VesselSparePendingPurchaseOrderRow> useData={useVesselSparePendingDeliveriesListData} config={config} />
    </VesselSparePendingDeliveriesListProvider>
  );
};

export default List;
